import {
  isDbDriverCollection,
  defaultDatasetConfiguration,
} from '@wix/wix-data-client-common'

const getCollectionName = config => config?.dataset?.collectionName

const isDatasetConfigured = config => !!getCollectionName(config)

const isDatasetConnectedToDbDriverCollection = ({ config, collections }) => {
  const collectionId = getCollectionName(config)
  const collection = collections.find(({ id }) => collectionId === id)
  if (!collection) {
    return false
  }
  return isDbDriverCollection(collection)
}

const getReadWriteType = config =>
  config?.dataset?.readWriteType || defaultDatasetConfiguration.readWriteType

export {
  isDatasetConfigured,
  isDatasetConnectedToDbDriverCollection,
  getCollectionName,
  getReadWriteType,
}
